/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { ISettingGroupDefinition } from "@nuance/hierarchical-settings-ui-domain";
import { IMainFrameViewModel } from "../Mainframe/MainframeViewModel";
import { CmdBuilder, IViewModel } from "@nuance/hap-components";

/**
 * MainView state interface
 */
export interface IMainViewState {
    definition: ISettingGroupDefinition;
    mainFrameVM: IMainFrameViewModel;
}

/**
 * MainView commands and command handler
 */
export class MainViewCommands {
    constructor() {
        const cb = new CmdBuilder();
        const cmds = {
            definitionChange: cb.bindCmd(this.definitionChangedHandler)
        };

        this.Cmds = cmds;
        this.Reducer = cb.buildReducer<IMainViewState>(cmds);
    }

    readonly Cmds;
    readonly Reducer;

    /////////////////////////////////////////////////////////////////
    // Command handlers
    /////////////////////////////////////////////////////////////////
    definitionChangedHandler = (state: IMainViewState, definition: ISettingGroupDefinition) => {
        state.definition = definition;
        return state;
    };
}

type IMainViewCmds = MainViewCommands["Cmds"];

/**
 * MainViewViewModel interface
 */
export type IMainViewViewModel = IViewModel<IMainViewState, IMainViewCmds>;
